<template>
  <div>
    <div id="home" v-if="this.$store.state.visible == true"></div>
    <div id="homeMobile" v-else></div>
  </div>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "home",
  data: () => ({}),
  created() {
    this.$store.commit("setTitle", "BOSON TI");
    this.$store.commit("setPageHeader", ["", "", "", "", false]);
  },
  mounted() {},
  computed: {},
  methods: {}
};
</script>

<style>
#home {
  background-image: url("../assets/bosonbg.svg");
  height: 100%;
  width: 95%;
  position: fixed;
  top: 0;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
#homeMobile {
  background-image: url("../assets/logoSVG.svg");
  height: 100%;
  width: 95%;
  position: fixed;
  top: 0;
  background-position: center;
  background-repeat: no-repeat;
}
</style>